(function () {
  var faqBlocks = document.querySelectorAll('.faq-block');
  if (!faqBlocks.length) return;

  var entities = [];

  faqBlocks.forEach(function (block) {
    var items = block.querySelectorAll('details');

    items.forEach(function (item) {
      var qEl = item.querySelector('summary');
      if (!qEl) return;

      var question = qEl.textContent.trim();
      if (!question) return;

      var clone = item.cloneNode(true);
      var summary = clone.querySelector('summary');
      if (summary) summary.remove();

      var answer = clone.textContent.trim();
      if (!answer) return;

      entities.push({
        "@type": "Question",
        "name": question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": answer
        }
      });
    });
  });

  if (!entities.length) return;

  if (document.querySelector('script[data-faq-schema="true"]')) return;

  var schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": entities
  };

  var script = document.createElement('script');
  script.type = 'application/ld+json';
  script.setAttribute('data-faq-schema', 'true');
  script.text = JSON.stringify(schema);
  document.head.appendChild(script);
})();